import { render, staticRenderFns } from "./SignCategories.vue?vue&type=template&id=21a2c60f&style=width%3A%201500px%3B&"
import script from "./SignCategories.vue?vue&type=script&lang=js&"
export * from "./SignCategories.vue?vue&type=script&lang=js&"
import style0 from "./SignCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports